import Axios from "axios";
import { saveMsg, updateMsg, failedMsg } from "../../../erpUtil";
import {
  getSpecialFFdata,
  saveSpecialFFdata,
  getSpecialFFdataList,
  downloadSpecialFFletter,
  cencleSpecialFFletter,
} from "../../../api";

import {
  SET_DATA_ENTRY_DETAILS,
  UN_SET_ADMIN_FORM_FILLUP_SUBJECT,
  SPECIAL_FF_STUDENT_DATA_LIST,
} from "../../../mutation-types";
const state = {
  studentInfo: {},
  specialffstudentList: [],
};
const getters = {
  getSpetialFFstuden(state) {
    return state.studentInfo;
  },
  getSpetialFFstudenList(state) {
    return state.specialffstudentList;
  },
};
const mutations = {
  [SET_DATA_ENTRY_DETAILS](state, data) {
    return (state.studentInfo = data);
  },
  [UN_SET_ADMIN_FORM_FILLUP_SUBJECT](state) {
    state.admin_form_fill_up_subject = [];
  },
  [SPECIAL_FF_STUDENT_DATA_LIST](state, data) {
    state.specialffstudentList = data;
  },
};
const actions = {
  getSpecialFFStudentList({ commit }, schema) {
    commit("UN_SET_ADMIN_FORM_FILLUP_SUBJECT");
    let data = schema;
    return new Promise(function (resolve, reject) {
      commit("SET_LOADING", { color: "primary" });
      Axios.get(getSpecialFFdataList, { params: data })
        .then(function (response) {
          console.log(response);
          let result = response.data.data;
          commit("SPECIAL_FF_STUDENT_DATA_LIST", result);
          resolve(response.data);
          commit("UNSET_LOADING");
        })
        .catch(function (error) {
          commit("SET_SNACKBAR", {
            msg: error.response.data.message,
            color: "red"
          });
          commit("GET_PBL_STUDENT_INFO");
          commit("UNSET_LOADING");
          //reject();
        });
    });
  },
  fetchDataEntryDetailsList({ commit }, schema) {
    commit("UN_SET_ADMIN_FORM_FILLUP_SUBJECT");
    let data = schema;
    return new Promise(function (resolve, reject) {
      commit("SET_LOADING", { color: "primary" });
      Axios.get(getSpecialFFdata, { params: data })
        .then(function (response) {
          console.log(response.data.data);
          let result = response.data.data;
          commit("SET_DATA_ENTRY_DETAILS", result);
          resolve(response.data);
          commit("UNSET_LOADING");
        })
        .catch(function (error) {
          commit("SET_SNACKBAR", {
            msg: error.response.data.message,
            color: "red"
          });
          commit("SET_DATA_ENTRY_DETAILS");
          commit("UNSET_LOADING");
          //reject();
        });
    });
  },

  formFillUpConfirmColUser({ commit, state }, formData) {
    return new Promise(function (resolve, reject) {
      commit("SET_LOADING", { color: "primary" });
      Axios.post(saveSpecialFFdata, formData)
        .then(function (response) {
          localStorage.removeItem("admin_form_fill_up_subject");
          if (response.data.status === "success") {
            commit("UN_SET_ADMIN_FORM_FILLUP_SUBJECT");
            commit("SET_SNACKBAR", {
              msg: saveMsg,
              color: "green"
            });
            resolve(response);
          } else {
            commit("SET_SNACKBAR", {
              msg: response.data.message,
              color: "red"
            });
            reject(response);
          }
        })
        .catch(function (error) {
          reject();
        })
        .then(always => {
          commit("UNSET_LOADING");
        });
    });
  },

  downloadLetterfile({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.get(`${downloadSpecialFFletter}/${id}`)
        .then((response) => {
          commit("UNSET_LOADING");

          if (response.data.status === "success" && response.data.data) {
            const fileUrl = response.data.data;
            window.open(fileUrl, "_blank"); // ✅ open the PDF file in a new tab
            resolve(response.data);
          } else {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "File not available",
              color: "red",
            });
            reject(response);
          }
        })
        .catch((error) => {
          commit("UNSET_LOADING");
          commit("SET_SNACKBAR", {
            msg: "Download failed. Please try again.",
            color: "red",
          });
          console.error("Error downloading letter:", error);
          reject(error);
        });
    });
  },

  cancelLetterfile({ commit }, id) {
    commit("SET_LOADING", { color: "primary" });

    return new Promise((resolve, reject) => {
      Axios.delete(`${cencleSpecialFFletter}/${id}`)
        .then((response) => {
          commit("UNSET_LOADING");

          if (response.data.status === "success") {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Letter cancelled successfully",
              color: "green",
            });
            resolve(response.data);
          } else {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Failed to cancel letter",
              color: "red",
            });
            reject(response);
          }
        })
        .catch((error) => {
          commit("UNSET_LOADING");
          commit("SET_SNACKBAR", {
            msg: "Cancel request failed. Please try again.",
            color: "red",
          });
          console.error("Error cancelling letter:", error);
          reject(error);
        });
    });
  },


};
export default {
  state,
  getters,
  actions,
  mutations
};
